import _ from 'lodash'
import mobile from 'scoreboard/components/mobile'
import conductor from 'scoreboard/components/conductor'
import guard from 'scoreboard/components/unsaved/guard'
import InfiniteScroller from 'scoreboard/components/infinite-scroller'
import scrollContainer from 'scoreboard/components/scroll-container'
import streamLoader from 'scoreboard/components/export/stream-loader'
import LoadingDots from 'scoreboard/components/loading-dots'
import StatefulView from './stateful-view'
import formatValue from 'scoreboard/components/format-value'
import i18n from 'scoreboard/components/i18n'
import reportConstants from 'scoreboard/reports/report-constants'
import user from 'scoreboard/components/user'

var ResultsView = StatefulView.extend({
	initialize: function (options) {
		this.options = options || {}
		_.defaults(this.options, { showHeaders: true })

		// if the report's label has changed, update the UI. This is primarily for dashboard report widgets,
		// because the display pane header takes care of the label for "real" reports
		this.listenTo(this.model, 'change:label', this.renderPanelHeader.bind(this))
	},

	render: function () {
		return this
	},

	context: function () {
		return {
			title : this.options.showLabel ? this.model.get('label') : null
		}
	},

	renderPanelHeader: function () {
		var label = _.escape(this.model.get('label'))
		this.$('.report-label')
			.toggleClass('is-not-displayed', !label)
			.find('h3').text(label)
	},

	/**
	 * Displays a banner if the number or results exceeds the max threshold (10k)
	 *
	 * @param {String} [options.msgProperty='report.customReport.warn.maxResults']
	 * @param {Number} [options.resultCount=this.model.metadata.resultCount]
	 */
	renderMaxResultsBanner: function(options = {}) {
		const metadata = this.model.metadata
		let {msgProperty = 'report.customReport.warn.maxResults',
			resultCount = _.get(metadata, 'numResults')} = options

		const max = user.isBuiltInAdmin() ? reportConstants.MAX_RESULTS_ADMIN :
			reportConstants.MAX_RESULTS
		if (resultCount >= max) {
			let msg = i18n.get(msgProperty, formatValue(
				{value: max, shorten: false}))
			this.$('.banner')
				.removeClass('is-not-displayed banner-error')
				.addClass('banner-warning')
				.html(`<div>${msg}</div>`)
		}
	},

	showHeaders: function (showHeaders) {
		this.options.showHeaders = showHeaders
		this._updateHeaderVisibility()
	},

	_updateHeaderVisibility: function () {
		this.$('thead').toggleClass('is-not-displayed', !this.options.showHeaders)
	},

	/**
	 * Disables or enables interactions on the report results; currently, that
	 * means clicking on the column headers to sort
	 */
	disable(disable) {
		this.sortableTable && this.sortableTable.disable(disable)
	},

	overview: function(e) {
		if (mobile.isTouchMoving()) {
			return
		}
		var id = this.$(e.target).data('id')
		guard.conditionallyRun(() => {
			conductor.overview(this.drilldownSection, id)
		})
	},

	initializeScrollableTable (streamAlreadyDoneCallback = _.noop) {
		if (this.scroller) {
			let method = mobile.isMobileOrientation() ? 'stopListening' : 'remove'
			_.invoke(this.scroller, method)
		}

		this.scroller = new InfiniteScroller({ el: this._getScrollContainer() })
		this._scrollerListener = this.scroller.dataReady.bind(this.scroller)

		this.listenTo(this.scroller, 'scroll', () => {
			if (this.results) {
				this.results.next.call(this.results)
			}
		})

		this.index = 0

		if (this.model.results) {
			this._observeStream(this.model.results)
		}

		//the model may already have received the first results before we've
		//setup the stream listener
		let initialData = this.model.initialData
		if (initialData) {
			this.renderResults(initialData)
			//handle case when initial chunk is small enough to fit on the screen
			//but there is more we can display, fill out until we require a scroll
			//see infinite-scroller.dataReady for more details
			this.results.on('data', this.scroller.dataReady.bind(this.scroller))
			//check if we need more data beyond the initial to fill the remaining space
			this.scroller.checkScroll()
		}

		//kick off in case it's currently waiting, if not this is a noop
		if (this.results) {
			this.results.resume()

			//stream might already have ended, check if any results were found
			if (this.results.done) {
				streamAlreadyDoneCallback()
			}

			if (this.parent) {
				streamLoader(this.parent, this.results)
			}
		}

		this.loadingDots = new LoadingDots({ el: this.$('.loading-dots-container') })
	},

	_getScrollContainer: function() {
		//#29190 derek says because we hide overflows on scrollable
		//containers for widgets, we need the scroll container to be
		//the panel-with-table to load incremental data in report widgets
		return this.options.dashboardWidget ? this.$('.panel-with-table')
			: scrollContainer(this.el)
	}

})

export default ResultsView

ResultsView.__filename__ = 'reports/common/results-view.js'
